import React from 'react';
import { useContent } from '../content/ContentContext';
import { Arrow, Check, Reveal, SectionHeader } from '../lib/ui';

const Platforms: React.FC = () => {
  const { platforms } = useContent();
  if (!platforms.visible) return null;

  return (
    <section id="plattformen" className="scroll-mt-20 py-24 md:py-32">
      <div className="container-site">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
          <SectionHeader eyebrow={platforms.eyebrow} title={platforms.title} intro={platforms.intro} />
          {platforms.logo && (
            <Reveal delay={0.1} className="shrink-0">
              <img src={platforms.logo} alt="DartCloud und Darts Basar" className="h-12 w-auto max-w-full object-contain sm:h-14 md:h-16" />
            </Reveal>
          )}
        </div>

        <div className="mt-12 md:mt-20 md:space-y-8">
          {platforms.items.map((p, i) => (
            <Reveal key={p.id}>
              <article className="border-t border-line py-12 first:border-t-0 first:pt-0 md:card md:overflow-hidden md:border-t-0 md:py-0">
                <div className={`grid items-end gap-0 md:grid-cols-2 ${i % 2 === 1 ? 'md:[&>*:first-child]:order-2' : ''}`}>
                  <div className="md:p-12 lg:p-14">
                    <div className="flex items-center gap-3">
                      <img src={p.icon} alt="" className="h-10 w-10 rounded-xl" />
                      <div>
                        <h3 className="text-xl font-semibold tracking-tight">{p.name}</h3>
                        <p className="text-sm text-fg-3">{p.tagline}</p>
                      </div>
                    </div>
                    <p className="mt-6 text-[15px] leading-relaxed text-fg-2 sm:text-base">{p.description}</p>
                    <ul className="mt-6 space-y-3">
                      {p.features.map((f) => (
                        <li key={f} className="flex items-start gap-3 text-[15px] text-fg">
                          <Check className="mt-0.5 h-5 w-5 shrink-0" />
                          <span>{f}</span>
                        </li>
                      ))}
                    </ul>
                    <div className="mt-8 flex flex-wrap items-center gap-3">
                      <a href={p.link} target="_blank" rel="noopener noreferrer" className="btn-secondary btn-sm">
                        {p.linkLabel} <Arrow className="h-4 w-4 -rotate-45" />
                      </a>
                      <span className="chip">{p.badge}</span>
                    </div>
                  </div>
                  <div className="relative mt-8 self-end md:mt-0 md:px-8 md:pt-10">
                    <div aria-hidden className="absolute inset-0 opacity-[0.12]" style={{ background: `radial-gradient(60% 60% at 50% 60%, ${p.accent}, transparent 70%)` }} />
                    <div className="screen-frame relative rounded-2xl border-b md:rounded-b-none md:border-b-0">
                      <img src={p.image} alt={`${p.name} Screenshot`} className="mt-8 block aspect-[2/1] w-full object-cover object-top" loading="lazy" />
                    </div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Platforms;
